import type {
  SearchResultItem,
  SpatialLayer,
} from '../../GlobalMapSearch.types';
import { runSpatialAttributeSearch } from '../spatial/spatialAttributeSearch';

interface RunStaticLayerSearchArgs {
  text: string;
  layers: SpatialLayer[];
  collected: SearchResultItem[];
  flush: () => void;
}

/**
 * Generic fuzzy search across active static spatial layers (fire stations,
 * AEDs, CRG sites, etc.) loaded into `state.spatialLayers.staticLayers`.
 */
export function runStaticLayerSearch({
  text,
  layers,
  collected,
  flush,
}: RunStaticLayerSearchArgs): void {
  runSpatialAttributeSearch({
    text,
    source: 'static',
    layers,
    collected,
    flush,
  });
}
